/// <reference types="./questionnaire.d.mts" />
import * as $when from "../../../../../app_config/app_config/when.mjs";
import * as $bright from "../../../../../bright/bright.mjs";
import * as $auth_guards from "../../../../../common/common/guards.mjs";
import * as $comment from "../../../../../common/data/comment.mjs";
import * as $connector from "../../../../../common/data/connector.mjs";
import * as $metadata from "../../../../../common/data/copilot_message/metadata.mjs";
import * as $data_point from "../../../../../common/data/data_point.mjs";
import * as $data_source from "../../../../../common/data/data_source.mjs";
import * as $project from "../../../../../common/data/project.mjs";
import * as $proposal from "../../../../../common/data/proposal.mjs";
import * as $question from "../../../../../common/data/proposal_element/question.mjs";
import * as $translate from "../../../../../common/data/translate.mjs";
import * as $language from "../../../../../common/data/translate/language.mjs";
import * as $user from "../../../../../common/data/user.mjs";
import * as $list_ from "../../../../../common_common/gleam/list/extra.mjs";
import * as $unsafe from "../../../../../common_common/gleam/unsafe.mjs";
import * as $colors from "../../../../../ds/ds/colors.mjs";
import * as $button from "../../../../../ds/ds/components/button.mjs";
import * as $checkbox from "../../../../../ds/ds/components/checkbox.mjs";
import * as $display_time from "../../../../../ds/ds/components/display_time.mjs";
import * as $dropdown from "../../../../../ds/ds/components/dropdown.mjs";
import * as $emoji_picker from "../../../../../ds/ds/components/emoji_picker.mjs";
import * as $input from "../../../../../ds/ds/components/input.mjs";
import * as $label from "../../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../../../../ds/ds/components/skeleton.mjs";
import * as $toggler from "../../../../../ds/ds/components/toggler.mjs";
import * as $tooltip from "../../../../../ds/ds/components/tooltip.mjs";
import * as $events from "../../../../../ds/ds/events.mjs";
import * as $icons from "../../../../../ds/ds/icons.mjs";
import * as $outline from "../../../../../ds/ds/outline.mjs";
import * as $ds_utils from "../../../../../ds/ds/utils.mjs";
import * as $bool from "../../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../../../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../../lustre/lustre/event.mjs";
import * as $mime_types from "../../../../../mime_types/mime_types.mjs";
import * as $css from "../../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../../sketch/sketch/css/length.mjs";
import * as $element from "../../../../../sketch_lustre/sketch/lustre/element.mjs";
import * as $html from "../../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $model from "../../../../data/model.mjs";
import * as $computed from "../../../../data/model/computed.mjs";
import * as $state from "../../../../data/model/state.mjs";
import { State } from "../../../../data/model/state.mjs";
import * as $msg from "../../../../data/msg.mjs";
import * as $proposals from "../../../../data/proposals.mjs";
import * as $route from "../../../../data/route.mjs";
import * as $copilot from "../../../../data/ui/copilot.mjs";
import * as $blocks from "../../../../elements/editors/blocks.mjs";
import * as $warn from "../../../../frontend/error/warn.mjs";
import * as $common from "../../../../frontend/view/common.mjs";
import * as $pagination from "../../../../frontend/view/components/pagination.mjs";
import * as $translated_text from "../../../../frontend/view/components/translated_text.mjs";
import * as $shared from "../../../../frontend/view/copilot/shared.mjs";
import * as $projects_common from "../../../../frontend/view/projects/show/common.mjs";
import * as $states from "../../../../frontend/view/projects/show/states.mjs";
import * as $sc from "../../../../frontend/view/styles/content_library.mjs";
import * as $dropdown_styles from "../../../../frontend/view/styles/dropdowns.mjs";
import * as $s from "../../../../frontend/view/styles/proposals.mjs";
import * as $node from "../../../../frontend/window/node.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../../../gleam.mjs";
import { clickUploadAttachment as click_upload_attachment } from "./questionnaire.ffi.ts";

const FILEPATH = "src/frontend/view/projects/show/questionnaire.gleam";

export class Props extends $CustomType {
  constructor(sheet, page, tab, project, proposal) {
    super();
    this.sheet = sheet;
    this.page = page;
    this.tab = tab;
    this.project = project;
    this.proposal = proposal;
  }
}

class QuestionProps extends $CustomType {
  constructor(question, index, total, data_sources, data_points, comments, language, disabled) {
    super();
    this.question = question;
    this.index = index;
    this.total = total;
    this.data_sources = data_sources;
    this.data_points = data_points;
    this.comments = comments;
    this.language = language;
    this.disabled = disabled;
  }
}

function select_paginated_questions(model, props, by_sheet, active_sheet) {
  let state = $bright.state(model);
  return $result.map(
    $dict.get(by_sheet, active_sheet),
    (questions) => {
      let start = props.page * state.proposals.block_page_size;
      let end = start + state.proposals.block_page_size;
      let _pipe = questions;
      let _pipe$1 = $list.sort(
        _pipe,
        (a, b) => { return $int.compare(a[1].qa_order, b[1].qa_order); },
      );
      return $list_.slice(_pipe$1, start, end);
    },
  );
}

function mode_bar(model, props) {
  let state = $bright.state(model);
  let $ = props.proposal.metadata;
  if ($ instanceof $proposal.Portal) {
    return $el.none();
  } else if ($ instanceof $proposal.Document) {
    let proposal = new Some(props.proposal);
    return $projects_common.mode_bar(proposal, state.route, true);
  } else if ($ instanceof $proposal.Questionnaire) {
    return $el.none();
  } else {
    let proposal = new Some(props.proposal);
    return $projects_common.mode_bar(proposal, state.route, true);
  }
}

function is_question_disabled(model, props, question) {
  let state = $bright.state(model);
  let user = $state.current_user(state);
  return $bool.guard(
    question.ai_processing,
    true,
    () => {
      return $bool.guard(
        $project.completed(props.project),
        true,
        () => {
          if (user instanceof Some) {
            let user$1 = user[0];
            return $bool.guard(
              $user.is_admin(user$1),
              false,
              () => {
                let is_owner = $list.contains(props.project.owners, user$1.id);
                return $bool.guard(
                  is_owner,
                  false,
                  () => { return !isEqual(new Some(user$1.id), question.owner); },
                );
              },
            );
          } else {
            return true;
          }
        },
      );
    },
  );
}

function on_spreadsheet_click(props, sheet) {
  let _pipe = props.proposal;
  let _pipe$1 = new $msg.UserClickedProposal(_pipe, sheet);
  let _pipe$2 = new $msg.Proposal(_pipe$1);
  return $e.on_click(_pipe$2);
}

function questions_spreadsheet_sheets(props, active_sheet) {
  let $ = props.proposal.metadata;
  if ($ instanceof $proposal.Portal) {
    return $el.none();
  } else if ($ instanceof $proposal.Document) {
    return $el.none();
  } else if ($ instanceof $proposal.Questionnaire) {
    let sheets = $.sheets;
    return $s.question_spreadsheet_sheets(
      toList([]),
      $list.map(
        sheets,
        (sheet) => {
          let sheet_ = new Some(sheet);
          let on_click = on_spreadsheet_click(props, sheet_);
          let $1 = isEqual(sheet_, active_sheet);
          if ($1) {
            return $s.active_spreadsheet_sheet(
              toList([on_click]),
              toList([$el.text(sheet)]),
            );
          } else {
            return $s.spreadsheet_sheet(
              toList([on_click]),
              toList([$el.text(sheet)]),
            );
          }
        },
      ),
    );
  } else {
    return $el.none();
  }
}

function questions_pagination(model, props) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let msg = (i) => {
    return new $msg.Proposal(new $msg.UserSelectedProposalPage(i));
  };
  return $pagination.page_selector(
    props.page,
    $model.compute_page_max(
      computed.displayed_questions_count,
      state.proposals.block_page_size,
    ),
    msg,
    true,
  );
}

function question_numbering(section, numbering, question_props) {
  let index = $int.to_string(question_props.index + 1);
  let total = $int.to_string(question_props.total);
  let default_question = (index + " / ") + total;
  return $s.question_number(
    toList([]),
    (() => {
      if (numbering instanceof $option.Some) {
        if (section instanceof $option.Some) {
          let numbering$1 = numbering[0];
          let section$1 = section[0];
          return toList([
            $h.text(section$1),
            $icons.tiny($icons.arrow_right_line()),
            $h.text(numbering$1),
          ]);
        } else {
          let numbering$1 = numbering[0];
          return toList([$h.text(numbering$1)]);
        }
      } else if (section instanceof $option.Some) {
        let section$1 = section[0];
        return toList([
          $h.text(section$1),
          $icons.tiny($icons.arrow_right_line()),
          $h.text(default_question),
        ]);
      } else {
        return toList([$h.text(default_question)]);
      }
    })(),
  );
}

function on_select_question(question, checked) {
  let id = question.id;
  let _pipe = new $msg.UserSelectedQuestion(id, checked);
  return new $msg.Proposal(_pipe);
}

function on_toggle_comment(question_props) {
  return $decode.then$(
    $decode.dynamic,
    (_) => {
      let id = question_props.question.id;
      let $ = $node.questions_container_height(id);
      if ($ instanceof Ok) {
        let offset = $[0][0];
        let scroll_height = $[0][1];
        let height = $[0][2];
        let _pipe = new $msg.UserToggleComment(
          id,
          offset,
          [scroll_height, height],
        );
        let _pipe$1 = new $msg.Proposal(_pipe);
        return $decode.success(_pipe$1);
      } else {
        return $decode.failure($unsafe.coerce(""), "");
      }
    },
  );
}

function comments_indicator(question_props) {
  let unread = $list.count(
    question_props.comments,
    (c) => { return !c.is_resolved; },
  );
  return $bool.lazy_guard(
    unread === 0,
    $el.none,
    () => {
      return $s.button_notification(
        toList([$html.text($int.to_string(unread))]),
      );
    },
  );
}

function comments_toggler(_, _1, question_props) {
  return $s.small_button(
    toList([$e.on("click", on_toggle_comment(question_props))]),
    toList([
      $icons.minuscule($icons.message()),
      $el.text("Comments"),
      comments_indicator(question_props),
    ]),
  );
}

function question_score(model, _, question_props) {
  let state = $bright.state(model);
  let question = question_props.question;
  let language = question_props.language;
  let $ = question.display.score;
  if ($ instanceof Some) {
    let score = $[0];
    return $s.confidence_score(
      toList([]),
      toList([
        $h.text("Confidence Score"),
        $s.confidence_score_highlight(
          score,
          toList([]),
          (() => {
            let value = $int.to_string($float.round(score * 100.0));
            let value$1 = $string.slice(value, 0, 5);
            return toList([$h.text(value$1 + " %")]);
          })(),
        ),
        (() => {
          let $1 = $translated_text.translated_explanation(
            question,
            state,
            language,
          );
          if ($1 instanceof Ok) {
            let explanation = $1[0];
            return $tooltip.tooltip(
              toList([]),
              $icons.tiny($icons.info()),
              $s.confidence_score_tooltip(
                toList([]),
                toList([$h.text(explanation)]),
              ),
            );
          } else {
            return $el.none();
          }
        })(),
      ]),
    );
  } else {
    return $h.div(toList([]), toList([]));
  }
}

function user_round_icon(user) {
  let $ = user.picture;
  if ($ instanceof $option.Some) {
    let picture = $[0];
    return $pp.picture(new $pp.Medium(), toList([$a.src(picture)]));
  } else {
    return $pp.initials(
      new $pp.Medium(),
      toList([]),
      toList([$el.text(user.initials)]),
    );
  }
}

function user_image(user, image) {
  return $s.comment_owner(
    toList([
      $common.name_small(
        toList([]),
        toList([
          (() => {
            if (image) {
              return user_round_icon(user);
            } else {
              return $el.none();
            }
          })(),
          $s.max_size_name(toList([$el.text(user.name)])),
        ]),
      ),
    ]),
  );
}

function add_comment_mention(model, question_props, collaborators) {
  let state = $bright.state(model);
  let users = collaborators;
  return $when.some(
    state.user,
    (connected_user) => {
      let id = question_props.question.id;
      return $s.comment_actions(
        toList([
          $dropdown.dropdown(
            (u) => {
              return new $msg.Comment(
                new $msg.UserAddMentionToDraftComment(id, u),
              );
            },
            toList([
              $dropdown.placeholder("Notify collaborator"),
              $dropdown.input_class($s.details_collaborators_class()),
              $dropdown.icon($icons.add_user()),
            ]),
            listPrepend(
              $dropdown.section("Select collaborators"),
              $list.filter_map(
                users,
                (user) => {
                  let is_owner = user.id === connected_user.sub;
                  return $bool.guard(
                    is_owner,
                    new Error(undefined),
                    () => {
                      let id$1 = user.id;
                      let name = user.name;
                      let picture = user.picture;
                      let initials = user.initials;
                      let icon = $pp.from_user(
                        picture,
                        initials,
                        new $pp.Medium(),
                      );
                      return new Ok(
                        (() => {
                          let _pipe = $dropdown.choice(name, id$1);
                          return $dropdown.with_icon(_pipe, icon);
                        })(),
                      );
                    },
                  );
                },
              ),
            ),
          ),
        ]),
      );
    },
  );
}

function mentions(model, question_props, mentions, draft) {
  return $bool.lazy_guard(
    $list.is_empty(mentions),
    $el.none,
    () => {
      let question_id = question_props.question.id;
      let state = $bright.state(model);
      let on_click = (user_tagged) => {
        let _pipe = user_tagged;
        let _pipe$1 = ((_capture) => {
          return new $msg.UserRemoveMentionFromDraftComment(
            question_id,
            _capture,
          );
        })(_pipe);
        return new $msg.Comment(_pipe$1);
      };
      let mentions$1 = $list.map(
        $list.reverse(mentions),
        (uid) => {
          let user = $list.find(
            state.organization.users,
            (u) => { return u.id === uid; },
          );
          return $when.ok(
            user,
            (user) => {
              if (draft) {
                return $s.clickable(
                  toList([$e.on_click(on_click(uid))]),
                  toList([user_round_icon(user)]),
                );
              } else {
                return user_round_icon(user);
              }
            },
          );
        },
      );
      if (draft) {
        return $s.mentions_list_draft(
          listPrepend($h.text("Notify:"), mentions$1),
        );
      } else {
        return $s.mentions_list_submitted(mentions$1);
      }
    },
  );
}

function add_comment(model, props, question_props) {
  let question = question_props.question;
  let state = $bright.state(model);
  let user_id = $state.current_user_id(state);
  let user = $list.find(
    state.organization.users,
    (u) => { return isEqual(new Some(u.id), user_id); },
  );
  let on_input = (s) => {
    return new $msg.Comment(new $msg.UserEditedComment(s, question.id));
  };
  let on_submit = new $msg.Comment(new $msg.UserSubmittedComment(question.id));
  let on_cancel = new $msg.Comment(new $msg.UserCanceledComment(question.id));
  let _block;
  let _pipe = $project.all_collaborators(props.project);
  _block = $list.filter_map(
    _pipe,
    (uid) => {
      return $list.find(
        state.organization.users,
        (u) => { return u.id === uid; },
      );
    },
  );
  let collaborators = _block;
  return $when.ok(
    user,
    (user) => {
      let _block$1;
      let _pipe$1 = state.draft_comments;
      let _pipe$2 = $dict.get(_pipe$1, question.id);
      _block$1 = $result.unwrap(_pipe$2, "");
      let value = _block$1;
      return $s.create_comment(
        toList([
          $s.comment_head(
            toList([
              user_image(user, true),
              add_comment_mention(model, question_props, collaborators),
            ]),
          ),
          mentions(
            model,
            question_props,
            (() => {
              let _pipe$3 = state.comments_draft_mentions;
              let _pipe$4 = $dict.get(_pipe$3, question.id);
              return $result.unwrap(_pipe$4, toList([]));
            })(),
            true,
          ),
          $s.comment_input(
            toList([
              $input.input(
                toList([
                  $input.id("comment_input_" + question.id),
                  $input.placeholder("Comment"),
                  $input.on_input(on_input),
                  $input.on_submit(on_submit),
                  $input.value(value),
                ]),
              ),
              $l.row(
                toList([$l.gap(8), $l.justify("end")]),
                toList([]),
                toList([
                  $button.secondary(
                    toList([
                      $a.disabled($string.is_empty(value)),
                      $e.on_click(on_cancel),
                    ]),
                    toList([$el.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([
                      $a.disabled($string.is_empty(value)),
                      $e.on_click(on_submit),
                    ]),
                    toList([$el.text("Submit")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function comment_react(model, comment, reacts) {
  let state = $bright.state(model);
  let users = $list.filter_map(
    reacts,
    (react) => {
      return $list.find(
        state.organization.users,
        (u) => { return u.id === react.owner; },
      );
    },
  );
  let $ = $list.map(users, (user) => { return user.name; });
  
  let _block;
  let _pipe = $option.map(state.user, (u) => { return u.sub; });
  _block = $option.unwrap(_pipe, "");
  let owner = _block;
  let does_owner_reacted = $list.find(users, (u) => { return u.id === owner; });
  return $when.ok(
    $list.first(reacts),
    (react) => {
      let _block$1;
      let _pipe$1 = reacts;
      let _pipe$2 = $list.length(_pipe$1);
      _block$1 = $int.to_string(_pipe$2);
      let count = _block$1;
      let value = (react.value + " ") + count;
      let _block$2;
      let _pipe$3 = new $comment.React(react.value, owner);
      let _pipe$4 = ((_capture) => {
        return new $msg.UserToggledReact(comment, _capture);
      })(_pipe$3);
      _block$2 = new $msg.Comment(_pipe$4);
      let on_click = _block$2;
      if (does_owner_reacted instanceof Ok) {
        return $s.comment_reacted(
          toList([$e.on_click(on_click)]),
          toList([$html.text(value)]),
        );
      } else {
        return $s.comment_react(
          toList([$e.on_click(on_click)]),
          toList([$html.text(value)]),
        );
      }
    },
  );
}

function comment_popup(model, props, _, comment, opened) {
  return $bool.lazy_guard(
    !opened,
    $el.none,
    () => {
      let state = $bright.state(model);
      let on_edit = $e.on_click(
        new $msg.Comment(new $msg.UserToggledCommentEdition(comment)),
      );
      let on_archive = $e.on_click(
        new $msg.Comment(new $msg.UserArchivedComment(comment.id)),
      );
      let _block;
      let _pipe = props.project.collaborators;
      _block = $list.filter_map(
        _pipe,
        (uid) => {
          return $list.find(
            state.organization.users,
            (u) => { return u.id === uid; },
          );
        },
      );
      let $ = _block;
      
      return $s.actions_popup(
        new None(),
        toList([$ds_utils.stop_propagation()]),
        toList([
          $s.action_option(
            toList([on_edit]),
            toList([
              $s.details_collaborators_icon($icons.edit_line()),
              $h.text("Edit"),
            ]),
          ),
          $s.action_option(
            toList([on_archive]),
            toList([
              $s.details_collaborators_icon($icons.archive()),
              $h.text("Delete"),
            ]),
          ),
        ]),
      );
    },
  );
}

function comment_head(model, props, question_props, comment, user) {
  let question = question_props.question;
  let state = $bright.state(model);
  let $ = comment.id;
  
  let on_toggle_more = $e.on_click(
    new $msg.Comment(new $msg.UserToggledCommentMore(comment.id)),
  );
  let own_comment = isEqual(
    (() => {
      let _pipe = state.user;
      return $option.map(_pipe, (u) => { return u.sub; });
    })(),
    new Some(comment.owner)
  );
  let _block;
  let _pipe = state.user;
  let _pipe$1 = $option.map(_pipe, (u) => { return u.sub; });
  _block = $option.unwrap(_pipe$1, "");
  let own_user_id = _block;
  let opened = isEqual(
    state.proposals.popup_more_comment_id,
    new Some(comment.id)
  );
  let on_pick_emoji = (value) => {
    return new $msg.Comment(
      new $msg.UserToggledReact(comment, new $comment.React(value, own_user_id)),
    );
  };
  let open_react_picker = new $msg.Comment(
    new $msg.UserToggleEmojiCommentPicker(comment.id),
  );
  let on_reply = $e.on_click(
    new $msg.Proposal(
      new $msg.UserFocusReplyComment("comment_input_" + question.id),
    ),
  );
  let on_check = $e.on_click(
    new $msg.Comment(new $msg.UserResolvedComment(comment)),
  );
  return $s.comment_head(
    toList([
      user_round_icon(user),
      (() => {
        let $1 = comment.is_resolved;
        if ($1) {
          return $html.text("(resolved)");
        } else {
          return $el.none();
        }
      })(),
      $s.comment_actions(
        toList([
          $s.comment_action(
            toList([on_reply]),
            toList([$icons.small($icons.reply())]),
          ),
          $s.comment_action(
            toList([on_check]),
            toList([$icons.small($icons.check())]),
          ),
          $s.comment_action(
            toList([$e.on_click(open_react_picker)]),
            toList([$icons.small($icons.emoji())]),
          ),
          $emoji_picker.emoji_picker(
            toList([
              $emoji_picker.id(comment.id),
              $emoji_picker.open(
                isEqual(
                  state.proposals.emoji_comment_picker_id,
                  new Some(comment.id)
                ),
              ),
              $emoji_picker.on_submit(on_pick_emoji),
              $emoji_picker.on_blur(open_react_picker),
            ]),
          ),
          (() => {
            if (own_comment) {
              return $s.comment_action(
                toList([on_toggle_more]),
                toList([$icons.small($icons.more())]),
              );
            } else {
              return $el.none();
            }
          })(),
          comment_popup(model, props, question_props, comment, opened),
        ]),
      ),
    ]),
  );
}

function comment_card(model, props, question_props, comment, user) {
  let state = $bright.state(model);
  let editable = $dict.get(state.comments_in_edition, comment.id);
  let on_edit = (s) => {
    return new $msg.Comment(
      new $msg.UserEditedCommentEditionValue(comment.id, s),
    );
  };
  let on_submit = new $msg.Comment(
    new $msg.UserSubmittedCommentEdition(comment),
  );
  let on_cancel = new $msg.Comment(
    new $msg.UserCancelCommentEdition(comment.id),
  );
  let id = $a.id("comment-" + comment.id);
  return $s.comment_card(
    comment.is_resolved,
    toList([id]),
    toList([
      comment_head(model, props, question_props, comment, user),
      $s.comment_header(
        toList([
          user_image(user, false),
          $display_time.display_time(comment.created_at),
        ]),
      ),
      (() => {
        if (editable instanceof Ok) {
          let value = editable[0];
          return $s.editable_comment(
            toList([
              $s.comment_value(
                toList([
                  $input.input(
                    toList([
                      $input.on_input(on_edit),
                      $input.on_submit(on_submit),
                      $input.value(value),
                      $input.enter_submit(),
                    ]),
                  ),
                ]),
              ),
              $s.comment_action(
                toList([$e.on_click(on_submit)]),
                toList([$icons.small($icons.check())]),
              ),
              $s.comment_action(
                toList([$e.on_click(on_cancel)]),
                toList([$icons.small($icons.cross())]),
              ),
            ]),
          );
        } else {
          return $s.comment_value(
            toList([
              $html.text(comment.value),
              (() => {
                let $ = $list.length(comment.history) > 1;
                if ($) {
                  return $s.edited_text(toList([$html.text("(edited)")]));
                } else {
                  return $el.none();
                }
              })(),
            ]),
          );
        }
      })(),
      $s.comment_reacts(
        (() => {
          let _pipe = comment.reacts;
          let _pipe$1 = $list.group(_pipe, (r) => { return r.value; });
          let _pipe$2 = $dict.values(_pipe$1);
          return $list.map(
            _pipe$2,
            (_capture) => { return comment_react(model, comment, _capture); },
          );
        })(),
      ),
      (() => {
        let $ = comment.mentions;
        if ($ instanceof $Empty) {
          return $el.none();
        } else {
          let m = $;
          return mentions(model, question_props, m, false);
        }
      })(),
    ]),
  );
}

function tree_comment(model, props, question_props, comment, first, last) {
  let state = $bright.state(model);
  let user = $list.find(
    state.organization.users,
    (u) => { return u.id === comment.owner; },
  );
  return $when.ok(
    user,
    (user) => {
      let comment$1 = comment_card(model, props, question_props, comment, user);
      if (first) {
        return comment$1;
      } else if (last) {
        return $s.end_line_tree(comment$1);
      } else {
        return $s.left_line_tree(comment$1);
      }
    },
  );
}

function comments_view(model, props, qprops) {
  let state = $bright.state(model);
  let $ = state.proposals.focus_comment;
  if (!($ instanceof $option.Some)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/view/projects/show/questionnaire",
      811,
      "comments_view",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 25679,
        end: 25750,
        pattern_start: 25690,
        pattern_end: 25718
      }
    )
  }
  let offset = $[0][1];
  let comments = $comment.sort_by_creation_date(qprops.comments);
  return $s.comment_container(
    offset,
    (() => {
      if (comments instanceof $Empty) {
        return toList([add_comment(model, props, qprops)]);
      } else {
        let comment = comments.head;
        let rest = comments.tail;
        let _pipe = toList([
          tree_comment(model, props, qprops, comment, true, false),
        ]);
        let _pipe$1 = $list.append(
          _pipe,
          (() => {
            let last = $list.length(rest) - 1;
            return $list.index_map(
              rest,
              (comment, i) => {
                let last$1 = i === last;
                return tree_comment(
                  model,
                  props,
                  qprops,
                  comment,
                  false,
                  last$1,
                );
              },
            );
          })(),
        );
        return $list.append(
          _pipe$1,
          toList([add_comment(model, props, qprops)]),
        );
      }
    })(),
  );
}

function comment_cards(model, props, question_props) {
  let $ = $bright.state(model);
  let proposals = $.proposals;
  let question = question_props.question;
  let $1 = proposals.comment_displayed_opened;
  let $2 = proposals.focus_comment;
  if ($1) {
    if ($2 instanceof $option.Some) {
      let c = $2[0];
      if (c[0] !== question.id) {
        return $s.placeholder_comment_card();
      } else {
        return comments_view(model, props, question_props);
      }
    } else {
      return $s.placeholder_comment_card();
    }
  } else {
    return $s.placeholder_comment_card();
  }
}

function ai_button(title, disabled, on_click) {
  return $s.improvement_button(
    toList([$e.on_click(on_click), $a.disabled(disabled)]),
    toList([$icons.minuscule($icons.sparkles()), $el.text(title)]),
  );
}

function question_improvements_button(model, props, question) {
  let state = $bright.state(model);
  let skip = $dict.get(state.proposals.improvements_conversations, question.id);
  return $bool.lazy_guard(
    $result.is_ok(skip),
    $el.none,
    () => {
      let user_id = $state.find_current_user_id(state);
      let owner = isEqual(question.owner, $option.from_result(user_id));
      return $bool.lazy_guard(
        !owner,
        $el.none,
        () => {
          return $s.question_improvements(
            toList([]),
            toList([
              ai_button(
                "Improve",
                question.ai_processing || question.validated,
                new $msg.Proposal(
                  new $msg.UserClickedAiImprove(props.proposal.id, question.id),
                ),
              ),
            ]),
          );
        },
      );
    },
  );
}

function improvement_input(model, disabled, id) {
  let state = $bright.state(model);
  return $s.improvements_input(
    toList([
      $a.value(
        (() => {
          let _pipe = state.proposals.conversations_input;
          let _pipe$1 = $dict.get(_pipe, id);
          return $result.unwrap(_pipe$1, "");
        })(),
      ),
      $a.disabled(disabled),
      $e.on_input(
        (_capture) => { return new $msg.UserEditedAiConversation(id, _capture); },
      ),
      $a.placeholder("Ask anything…"),
      $e.on(
        "keydown",
        $decode.then$(
          $decode.dynamic,
          (event) => {
            return $decode.then$(
              $decode.field(
                "metaKey",
                $decode.bool,
                (meta) => {
                  return $decode.field(
                    "key",
                    $decode.string,
                    (key) => {
                      if (key === "Enter") {
                        return $decode.success(true);
                      } else {
                        return $decode.success(false);
                      }
                    },
                  );
                },
              ),
              (success) => {
                let return$ = () => {
                  return $decode.failure($unsafe.coerce(""), "");
                };
                return $bool.lazy_guard(
                  !success,
                  return$,
                  () => {
                    $input.blur_target(event);
                    return $decode.success(
                      new $msg.UserSubmittedAiConversation(id),
                    );
                  },
                );
              },
            );
          },
        ),
      ),
    ]),
  );
}

function improvements_actions(thread_id) {
  let on_click = (_capture) => {
    return new $msg.UserClickedAiPreset(thread_id, _capture);
  };
  return $l.row(
    toList([$l.gap(8)]),
    toList([]),
    toList([
      ai_button("Make shorter", false, on_click("Make shorter")),
      ai_button("Make longer", false, on_click("Make longer")),
    ]),
  );
}

function improvements_conversation_messages(
  model,
  _,
  question,
  disabled,
  thread_id
) {
  let state = $bright.state(model);
  let $ = $list.key_find(state.copilot.threads, thread_id);
  if ($ instanceof Ok) {
    let thread = $[0];
    let loading = disabled || $copilot.is_thread_loading(thread);
    let accept = new $msg.UserClickedAiAcceptAnswer(question, thread_id);
    let refuse = new $msg.UserClickedAiEndConversation(question.id);
    return $s.improvements_conversation_messages(
      toList([]),
      toList([
        $l.row(
          toList([$l.gap(8)]),
          toList([]),
          toList([
            $s.validate_button(
              toList([$a.disabled(loading), $e.on_click(accept)]),
              toList([
                $icons.minuscule($icons.checkmark()),
                $el.text("Accept answer"),
              ]),
            ),
            $s.cancel_button(
              toList([$a.disabled(loading), $e.on_click(refuse)]),
              toList([
                $icons.minuscule($icons.cross()),
                $el.text("End conversation"),
              ]),
            ),
          ]),
        ),
        $l.fragment(
          $list.index_map(
            thread.messages,
            (message, index) => {
              let is_last = index === 0;
              let $1 = message.metadata;
              if ($1 instanceof $metadata.Deprecated) {
                return $el.none();
              } else if ($1 instanceof $metadata.Errored) {
                return $l.column(
                  toList([$l.align("start")]),
                  toList([]),
                  toList([
                    $l.column(
                      toList([$l.gap(16), $l.align("start")]),
                      toList([]),
                      toList([
                        $s.error_response_bubble(
                          toList([]),
                          toList([
                            $h.text("An internal error happened at Steerlab.\n"),
                            $h.text(
                              "Please, contact your administrator, or restart the conversation.",
                            ),
                          ]),
                        ),
                      ]),
                    ),
                  ]),
                );
              } else if ($1 instanceof $metadata.System) {
                return $el.none();
              } else if ($1 instanceof $metadata.Developer) {
                return $el.none();
              } else if ($1 instanceof $metadata.User) {
                let content = $1.content;
                return $l.fragment(
                  toList([
                    $shared.show_loading_answer(is_last),
                    $s.improvement_user_bubble(
                      toList([]),
                      toList([
                        $s.user_bubble(toList([]), toList([$el.text(content)])),
                      ]),
                    ),
                  ]),
                );
              } else if ($1 instanceof $metadata.Tool) {
                return $el.none();
              } else {
                let $2 = $1.tool_calls;
                if ($2 instanceof $option.Some) {
                  return $shared.tool_bubble(is_last);
                } else {
                  let $3 = $1.content;
                  if ($3 instanceof $option.Some) {
                    let content = $3[0];
                    return $s.improvement_assistant_bubble(
                      toList([]),
                      toList([$s.assistant_bubble(toList([]), content)]),
                    );
                  } else {
                    return $el.none();
                  }
                }
              }
            },
          ),
        ),
      ]),
    );
  } else {
    return improvements_actions(thread_id);
  }
}

function question_improvements_conversation(model, props, question) {
  let state = $bright.state(model);
  let id = $dict.get(state.proposals.improvements_conversations, question.id);
  return $when.ok(
    id,
    (id) => {
      let id$1 = (((props.proposal.id + "_") + question.id) + "_") + id;
      let thread = $list.key_find(state.copilot.threads, id$1);
      let thread$1 = $option.from_result(thread);
      let disabled = $copilot.is_input_disabled(thread$1);
      let _pipe = $s.improvements_conversations(
        toList([]),
        toList([
          improvements_conversation_messages(
            model,
            props,
            question,
            disabled,
            id$1,
          ),
          $s.improvements_input_wrapper(
            toList([]),
            toList([
              improvement_input(model, disabled, id$1),
              $h.div(
                toList([$e.on_click(new $msg.UserSubmittedAiConversation(id$1))]),
                toList([$icons.small($icons.paper_plane())]),
              ),
            ]),
          ),
        ]),
      );
      return $el.map(_pipe, (var0) => { return new $msg.Proposal(var0); });
    },
  );
}

function question_attachments(props, question_props) {
  let question = question_props.question;
  let disabled = question_props.disabled;
  let is_empty = $list.is_empty(question.metadata.attachments);
  return $bool.lazy_guard(
    is_empty,
    $el.none,
    () => {
      return $s.question_attachments(
        toList([]),
        toList([
          $l.row(
            toList([$l.gap(8), $l.wrap("wrap")]),
            toList([]),
            $list.filter_map(
              question.metadata.attachments,
              (attachment) => {
                return $result.map(
                  $mime_types.from_string(attachment.mime_type),
                  (mime) => {
                    let on_delete = $e.on_click(
                      new $msg.Proposal(
                        new $msg.UserDeletedAttachment(
                          props.proposal,
                          question,
                          attachment,
                        ),
                      ),
                    );
                    return $s.attachment_pill(
                      toList([]),
                      toList([
                        $icons.tiny(
                          $ds_utils.select_icon(mime, new $connector.Steerlab()),
                        ),
                        $s.attachment_text(
                          toList([]),
                          toList([$h.text(attachment.name)]),
                        ),
                        (() => {
                          if (disabled) {
                            return $el.none();
                          } else {
                            return $s.attachment_close(
                              toList([on_delete]),
                              toList([$icons.tiny($icons.cross())]),
                            );
                          }
                        })(),
                      ]),
                    );
                  },
                );
              },
            ),
          ),
        ]),
      );
    },
  );
}

function actions_popup(opened, props, question, can_edit_proposal) {
  let proposal_id = props.proposal.id;
  let question_id = question.id;
  return $bool.lazy_guard(
    !opened,
    $el.none,
    () => {
      let on_click_add_question_bank = $e.on_click(
        new $msg.Proposal(
          new $msg.UserClickedAddToQuestionBank(proposal_id, question_id),
        ),
      );
      let _block;
      if (can_edit_proposal) {
        _block = $e.on_click(
          new $msg.Proposal(
            new $msg.UserDisplayedDeleteQuestionInProposalModal(
              proposal_id,
              question_id,
            ),
          ),
        );
      } else {
        _block = $e.on_click(
          $warn.action_forbidden(
            new Some("You are not allowed to remove questions in this proposal"),
          ),
        );
      }
      let on_click_remove_question = _block;
      let on_click_add_attachment = $e.on(
        "click",
        $decode.then$(
          $decode.dynamic,
          (_) => {
            click_upload_attachment();
            return $decode.failure($unsafe.coerce(""), "");
          },
        ),
      );
      return $s.actions_popup(
        new $option.None(),
        toList([$ds_utils.stop_propagation()]),
        toList([
          $s.add_attachment_input(
            toList([
              $a.id("projects-show-questionnaire-upload"),
              $a.type_("file"),
              $events.on_files_change(
                (files) => {
                  let return$ = () => {
                    return $decode.failure($unsafe.coerce(""), "");
                  };
                  return $bool.lazy_guard(
                    $list.is_empty(files),
                    return$,
                    () => {
                      return $decode.success(
                        new $msg.Proposal(
                          new $msg.UserChoseAttachment(
                            props.proposal,
                            question,
                            files,
                          ),
                        ),
                      );
                    },
                  );
                },
              ),
            ]),
          ),
          $s.action_title(toList([]), toList([$h.text("Actions")])),
          $s.action_option(
            toList([on_click_add_attachment]),
            toList([
              $s.details_collaborators_icon($icons.upload()),
              $h.text("Add attachment"),
            ]),
          ),
          $s.action_option(
            toList([on_click_add_question_bank]),
            toList([
              $s.details_collaborators_icon($icons.add()),
              $h.text("Add to question bank"),
            ]),
          ),
          $s.action_option(
            toList([on_click_remove_question]),
            toList([
              $s.details_collaborators_icon($outline.trash()),
              $h.text("Remove question"),
            ]),
          ),
        ]),
      );
    },
  );
}

function menu_toggler(model, props, question_props) {
  let state = $bright.state(model);
  let user = $state.current_user(state);
  let _block;
  let _pipe = $option.map(user, $auth_guards.edit_proposal);
  _block = $option.unwrap(_pipe, false);
  let can_edit_proposal = _block;
  let question = question_props.question;
  let current_user = $state.current_user_id(state);
  let opened = isEqual(
    state.proposals.more_question_opened,
    new Some(question.id)
  );
  let on_toggle_more = new $msg.Proposal(
    new $msg.UserToggledQuestionMenu(question.id),
  );
  let on_toggle_more$1 = $e.on_click(on_toggle_more);
  let _block$1;
  let _pipe$1 = (!isEqual(current_user, question_props.question.owner));
  let _pipe$2 = $bool.or(_pipe$1, question_props.question.ai_processing);
  let _pipe$3 = $bool.or(_pipe$2, $project.completed(props.project));
  _block$1 = $a.disabled(_pipe$3);
  let actions_disabled = _block$1;
  return $s.button_icon(
    opened,
    toList([on_toggle_more$1, actions_disabled]),
    toList([
      $icons.medium($icons.more()),
      actions_popup(opened, props, question, can_edit_proposal),
    ]),
  );
}

function make_filters_text(model) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let len_displayed = $list.length(computed.displayed_questions);
  let _block;
  let $ = state.proposals.filters;
  let $1 = $.owner;
  if ($1 instanceof $option.None) {
    let $2 = $.status;
    if ($2 instanceof $proposal.AllStatus) {
      _block = false;
    } else {
      _block = true;
    }
  } else {
    _block = true;
  }
  let is_filters_active = _block;
  if (is_filters_active) {
    return (("Filter " + "( ") + $int.to_string(len_displayed)) + " )";
  } else {
    return "Filter";
  }
}

function proposal_filters(model, props) {
  let state = $bright.state(model);
  return $bool.lazy_guard(
    !state.proposals.filters_opened,
    $el.none,
    () => {
      let proposal_collaborators = $project.all_collaborators(props.project);
      let other_choices = $css.class$(
        toList([$css.padding_("10px 12px"), $css.border_radius($length.px(10))]),
      );
      return $l.row(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $dropdown.dropdown(
            (var0) => { return new $msg.UserUpdatedProposalFiltersStatus(var0); },
            toList([
              $dropdown.placeholder("No status selected"),
              $dropdown.selected(new Some(state.proposals.filters.status)),
              $dropdown.panel_class($dropdown_styles.spacing()),
              $dropdown.show_arrow(),
              $dropdown.input_class(
                $css.class$(
                  toList([
                    $css.compose(
                      $css.class$(
                        toList([
                          (() => {
                            let $ = state.proposals.filters.status;
                            if ($ instanceof $proposal.Validated) {
                              return $css.compose($dropdown_styles.success());
                            } else if ($ instanceof $proposal.InReview) {
                              return $css.compose($dropdown_styles.current());
                            } else {
                              return $css.none();
                            }
                          })(),
                          $css.compose(other_choices),
                          $css.min_width($length.px(125)),
                        ]),
                      ),
                    ),
                  ]),
                ),
              ),
              $dropdown.disabled($list.is_empty(proposal_collaborators)),
            ]),
            toList([
              (() => {
                let _pipe = $dropdown.choice(
                  "All status",
                  new $proposal.AllStatus(),
                );
                return $dropdown.with_class(_pipe, $dropdown_styles.white());
              })(),
              (() => {
                let _pipe = $dropdown.choice(
                  "In review",
                  new $proposal.InReview(),
                );
                return $dropdown.with_class(
                  _pipe,
                  $css.class$(
                    toList([
                      $css.compose($dropdown_styles.current()),
                      $css.compose(other_choices),
                    ]),
                  ),
                );
              })(),
              (() => {
                let _pipe = $dropdown.choice(
                  "Validated",
                  new $proposal.Validated(),
                );
                return $dropdown.with_class(
                  _pipe,
                  $css.class$(
                    toList([
                      $css.compose($dropdown_styles.success()),
                      $css.compose(other_choices),
                    ]),
                  ),
                );
              })(),
            ]),
          ),
          $dropdown.dropdown(
            (var0) => { return new $msg.UserUpdatedProposalFiltersOwner(var0); },
            toList([
              $dropdown.placeholder("No collaborator selected"),
              $dropdown.selected(new Some(state.proposals.filters.owner)),
              $dropdown.panel_class($dropdown_styles.spacing()),
              $dropdown.show_arrow(),
              $dropdown.input_class(
                $css.class$(toList([$css.min_width($length.px(200))])),
              ),
            ]),
            listPrepend(
              (() => {
                let _pipe = $dropdown.choice("All owners", new None());
                return $dropdown.with_class(_pipe, $dropdown_styles.white());
              })(),
              $list.filter_map(
                state.organization.users,
                (user) => {
                  let user_in_proposal = $list.contains(
                    proposal_collaborators,
                    user.id,
                  );
                  return $bool.guard(
                    !user_in_proposal,
                    new Error(undefined),
                    () => {
                      let id = user.id;
                      let name = user.name;
                      let picture = user.picture;
                      let initials = user.initials;
                      let icon = $pp.from_user(
                        picture,
                        initials,
                        new $pp.Medium(),
                      );
                      let _pipe = $dropdown.choice(name, new Some(id));
                      let _pipe$1 = $dropdown.with_icon(_pipe, icon);
                      let _pipe$2 = $dropdown.with_class(
                        _pipe$1,
                        $dropdown_styles.white(),
                      );
                      return new Ok(_pipe$2);
                    },
                  );
                },
              ),
            ),
          ),
        ]),
      );
    },
  );
}

function blocks_actions(model, props) {
  let state = $bright.state(model);
  let center = $l.align("center");
  let space_between = $l.justify("space-between");
  let on_filters_click = $e.on_click(new $msg.UserToggledFilterProposal());
  return $l.row(
    toList([$l.gap(8), center, space_between]),
    toList([]),
    toList([
      (() => {
        let _pipe = $l.row(
          toList([$l.gap(32), center, space_between]),
          toList([]),
          toList([
            $s.filters_button(
              state.proposals.filters_opened,
              toList([on_filters_click]),
              toList([
                $icons.small($icons.filters()),
                $h.text(make_filters_text(model)),
              ]),
            ),
            proposal_filters(model, props),
          ]),
        );
        return $element.map(
          _pipe,
          (var0) => { return new $msg.Proposal(var0); },
        );
      })(),
      (() => {
        let _pipe = $projects_common.proposal_collaborators(
          model,
          props.project,
          props.proposal,
        );
        return $element.map(_pipe, (var0) => { return new $msg.Project(var0); });
      })(),
    ]),
  );
}

function collaborator_button(model, props, question) {
  let state = $bright.state(model);
  let $ = question.assign_processing;
  if ($) {
    return $skeleton.skeleton(150, 35);
  } else {
    let disabled = (!$list.contains(state.permissions, "rfp:users:add") || question.assign_processing) || $project.completed(
      props.project,
    );
    return $l.fragment(
      toList([
        $dropdown.dropdown(
          (selected) => {
            let _pipe = new $msg.UserSelectedElementOwner(
              question.id,
              question.proposal_id,
              selected,
            );
            return new $msg.Proposal(_pipe);
          },
          toList([
            $dropdown.placeholder("Add collaborator"),
            $dropdown.input_class($s.details_collaborators_class()),
            $dropdown.panel_right(),
            $dropdown.disabled(disabled),
            $dropdown.selected(question.owner),
          ]),
          listPrepend(
            $dropdown.section("Select collaborator"),
            (() => {
              let collaborators = $project.all_collaborators(props.project);
              return $list.filter_map(
                collaborators,
                (user) => {
                  return $result.try$(
                    $list.find(
                      state.organization.users,
                      (u) => { return u.id === user; },
                    ),
                    (user) => {
                      let id = user.id;
                      let picture = user.picture;
                      let initials = user.initials;
                      let name = $user.short_name(user);
                      let icon = $pp.from_user(
                        picture,
                        initials,
                        new $pp.Small(),
                      );
                      return new Ok(
                        (() => {
                          let _pipe = $dropdown.choice(name, id);
                          return $dropdown.with_icon(_pipe, icon);
                        })(),
                      );
                    },
                  );
                },
              );
            })(),
          ),
        ),
      ]),
    );
  }
}

function on_question_validation(question) {
  return $toggler.on_change(
    (validated) => {
      let _pipe = new $msg.UserChangedQuestionValidated(question, validated);
      return new $msg.Proposal(_pipe);
    },
  );
}

function question_status(question, disabled) {
  return $s.question_status(
    toList([]),
    toList([
      $l.row(
        toList([$l.align("center"), $l.gap(8)]),
        toList([]),
        toList([
          $toggler.toggler(
            toList([
              $toggler.active(question.validated),
              $toggler.disabled(disabled),
              on_question_validation(question),
            ]),
          ),
          (() => {
            let $ = question.validated;
            if ($) {
              if (disabled) {
                return $s.colored_text($colors.light.grey_800, "Validated");
              } else {
                return $s.colored_text($colors.light.success_800, "Validated");
              }
            } else if (disabled) {
              return $s.colored_text($colors.light.grey_800, "In review");
            } else {
              return $s.colored_text($colors.light.blue_800, "In review");
            }
          })(),
        ]),
      ),
    ]),
  );
}

function question_card_header(model, props, question_props) {
  let state = $bright.state(model);
  let question = question_props.question;
  let language = question_props.language;
  let _block;
  let $1 = question.metadata;
  if ($1 instanceof $question.PortalQuestion) {
    let section_name = $1.section_name;
    _block = [new Some(section_name), new None()];
  } else {
    let numbering = $1.numbering;
    let section = $1.section;
    _block = [section, numbering];
  }
  let $ = _block;
  let section = $[0];
  let numbering = $[1];
  let is_selected = $proposals.is_question_selected(
    state.proposals,
    question.id,
  );
  return $s.question_card_header(
    toList([]),
    toList([
      $checkbox.checkbox(
        $checkbox.checked(is_selected),
        question_props.disabled,
        (_capture) => { return on_select_question(question, _capture); },
      ),
      question_numbering(section, numbering, question_props),
      question_status(question, question_props.disabled),
      $s.question_owner(
        toList([]),
        toList([
          collaborator_button(model, props, question),
          comments_toggler(model, props, question_props),
          menu_toggler(model, props, question_props),
        ]),
      ),
      $s.question_question(
        $translated_text.translated_question(question, state, language),
      ),
    ]),
  );
}

function yes_no_radio(model, props, question_props, value) {
  let project = props.project;
  let question = question_props.question;
  let language = question_props.language;
  let selected = isEqual(
    $projects_common.yes_no_answer(question),
    new Ok(value)
  );
  let disabled = $projects_common.is_question_enabled(model, project, question);
  let on_click = new $msg.UserUpdatedProposalQuestionYesNo(question, value);
  let title = $translate.yes_no_answer(value, language);
  return $s.radio_wrapper(
    toList([$e.on_click(on_click)]),
    toList([$s.radio_button(selected, disabled), $el.text(title)]),
  );
}

function question_yes_no(model, props, question_props) {
  let question = question_props.question;
  let should_skip = !$list.contains(question.kind, new $question.YesNo());
  return $bool.lazy_guard(
    should_skip,
    $el.none,
    () => {
      let _pipe = $s.question_body(
        toList([]),
        toList([
          $l.column(
            toList([$l.gap(10), $l.align("start")]),
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(8)]),
                toList([]),
                toList([
                  yes_no_radio(
                    model,
                    props,
                    question_props,
                    new $translate.Yes(),
                  ),
                  yes_no_radio(
                    model,
                    props,
                    question_props,
                    new $translate.No(),
                  ),
                  yes_no_radio(
                    model,
                    props,
                    question_props,
                    new $translate.NA(),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
      return $element.map(_pipe, (var0) => { return new $msg.Proposal(var0); });
    },
  );
}

function multiple_choice_radio(model, props, question_props, choice) {
  let project = props.project;
  let question = question_props.question;
  let selected = isEqual(question.answer.choice, new Some(choice));
  let disabled = $projects_common.is_question_enabled(model, project, question);
  let on_click = new $msg.UserUpdatedProposalQuestionChoice(question, choice);
  return $s.radio_wrapper(
    toList([$e.on_click(on_click)]),
    toList([$s.radio_button(selected, disabled), $el.text(choice)]),
  );
}

function question_multiple_choice(model, props, question_props) {
  let question = question_props.question;
  let are_choices_absent = $list.is_empty(question.choices);
  let no_choices = !$list.contains(
    question.kind,
    new $question.MultipleChoice(),
  );
  let should_skip = no_choices || are_choices_absent;
  return $bool.lazy_guard(
    should_skip,
    $el.none,
    () => {
      let _pipe = $s.question_body(
        toList([]),
        toList([
          $l.column(
            toList([$l.gap(10), $l.align("start")]),
            toList([]),
            toList([
              $l.column(
                toList([$l.gap(8), $l.wrap("wrap"), $l.justify("start")]),
                toList([]),
                $list.map(
                  question.choices,
                  (choice) => {
                    return multiple_choice_radio(
                      model,
                      props,
                      question_props,
                      choice,
                    );
                  },
                ),
              ),
            ]),
          ),
        ]),
      );
      return $element.map(_pipe, (var0) => { return new $msg.Proposal(var0); });
    },
  );
}

function question_answer_or_loader(props, question, answer, next) {
  let $ = props.proposal.metadata.languages;
  if ($ instanceof $Empty) {
    return next($question.get_answer_text(question.answer));
  } else {
    let $1 = $.tail;
    if ($1 instanceof $Empty) {
      return next($question.get_answer_text(question.answer));
    } else if (answer instanceof Ok) {
      let answer$1 = answer[0];
      return next(answer$1);
    } else {
      return $el.none();
    }
  }
}

function is_question_editable(is_hint, is_owner, in_progress) {
  return $blocks.editable(!((is_hint || !is_owner) || !in_progress));
}

function question_long_answer(model, props, question_props) {
  let question = question_props.question;
  let language = question_props.language;
  let should_skip = !$list.contains(question.kind, new $question.Long());
  return $bool.lazy_guard(
    should_skip,
    $el.none,
    () => {
      let state = $bright.state(model);
      let user_id = $state.find_current_user_id(state);
      let is_hint = $question.is_hint(question);
      let is_owner = isEqual(
        $option.to_result(question.owner, undefined),
        user_id
      );
      let in_progress = !$project.completed(props.project);
      let editable = is_question_editable(is_hint, is_owner, in_progress);
      let answer = $translated_text.translated_answer(question, state, language);
      return question_answer_or_loader(
        props,
        question,
        answer,
        (answer) => {
          let _pipe = $blocks.view(
            is_hint,
            listPrepend(
              $blocks.content(answer),
              listPrepend(editable, $blocks.on_events()),
            ),
          );
          let _pipe$1 = $element.map(
            _pipe,
            (_capture) => {
              return new $msg.UserUpdatedProposalQuestion(
                question,
                _capture,
                language,
              );
            },
          );
          return $element.map(
            _pipe$1,
            (var0) => { return new $msg.Proposal(var0); },
          );
        },
      );
    },
  );
}

function question_body_display(model, props, question_props) {
  return $l.fragment(
    toList([
      $s.question_body(
        toList([]),
        toList([
          question_long_answer(model, props, question_props),
          question_improvements_button(model, props, question_props.question),
          question_attachments(props, question_props),
        ]),
      ),
      question_improvements_conversation(model, props, question_props.question),
      question_yes_no(model, props, question_props),
      question_multiple_choice(model, props, question_props),
    ]),
  );
}

function question_body(model, props, question_props) {
  let languages = props.proposal.metadata.languages;
  let $ = question_props.question.ai_processing;
  if ($) {
    return $states.question_body_skeleton();
  } else if (languages instanceof $Empty) {
    return question_body_display(model, props, question_props);
  } else {
    let $1 = languages.tail;
    if ($1 instanceof $Empty) {
      return question_body_display(model, props, question_props);
    } else {
      let state = $bright.state(model);
      let question = question_props.question;
      let language = question_props.language;
      let $2 = $translated_text.translated_answer(question, state, language);
      if ($2 instanceof Ok) {
        return question_body_display(model, props, question_props);
      } else {
        return $states.question_body_skeleton();
      }
    }
  }
}

function question_card(model, props, question_props) {
  let z_index = 9000 - question_props.index;
  let id = "question-" + question_props.question.id;
  return $s.question_card(
    z_index,
    toList([$a.id(id)]),
    toList([
      question_card_header(model, props, question_props),
      question_body(model, props, question_props),
      $s.question_sources(
        toList([]),
        toList([
          question_score(model, props, question_props),
          $common.sources_row(
            model,
            question_props.question.id,
            question_props.language,
            question_props.data_points,
            question_props.data_sources,
          ),
        ]),
      ),
    ]),
  );
}

function all_questions_cards(model, props, questions) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  return $list.map(
    questions,
    (_use0) => {
      let question = _use0[1];
      let sources = $proposals.get_question_sources(state.proposals, question);
      return [
        question.id,
        question_card(
          model,
          props,
          new QuestionProps(
            question,
            question.qa_order,
            computed.sheet_questions_count,
            sources[0],
            sources[1],
            (() => {
              let _pipe = $list.key_find(state.comments, question.id);
              return $result.unwrap(_pipe, toList([]));
            })(),
            $projects_common.get_language(state.language, props.proposal),
            is_question_disabled(model, props, question),
          ),
        ),
      ];
    },
  );
}

function questions_list(model, props, questions, active_sheet) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let comments_displayed = state.proposals.comment_displayed_opened;
  return $s.questions_comments_container(
    toList([]),
    toList([
      $s.questions_wrapper(
        toList([]),
        toList([
          $s.questions_container(
            toList([]),
            (() => {
              let _pipe = questions;
              let _pipe$1 = ((_capture) => {
                return all_questions_cards(model, props, _capture);
              })(_pipe);
              let _pipe$2 = $list.index_fold(
                _pipe$1,
                toList([]),
                (acc, val, index) => {
                  return listPrepend(
                    [$int.to_string(index), $s.separator()],
                    listPrepend(val, acc),
                  );
                },
              );
              let _pipe$3 = $list.rest(_pipe$2);
              let _pipe$4 = $result.unwrap(_pipe$3, toList([]));
              return $list.reverse(_pipe$4);
            })(),
          ),
          questions_pagination(model, props),
          questions_spreadsheet_sheets(props, active_sheet),
        ]),
      ),
      (() => {
        let $ = state.proposals.focus_comment;
        if (comments_displayed) {
          if ($ instanceof $option.Some) {
            let target_id = $[0][0];
            let heights = $[0][2];
            let $1 = $list.key_find(questions, target_id);
            if ($1 instanceof Ok) {
              let question = $1[0];
              let comments = $list.key_find(state.comments, question.id);
              let comments$1 = $result.unwrap(comments, toList([]));
              return $s.comments_container(
                heights,
                toList([]),
                toList([
                  comment_cards(
                    model,
                    props,
                    new QuestionProps(
                      question,
                      question.qa_order,
                      computed.sheet_questions_count,
                      toList([]),
                      toList([]),
                      comments$1,
                      $projects_common.get_language(
                        state.language,
                        props.proposal,
                      ),
                      is_question_disabled(model, props, question),
                    ),
                  ),
                ]),
              );
            } else {
              return $el.none();
            }
          } else {
            return $el.none();
          }
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function change_owner_popup(users, proposal_id) {
  return $sc.change_owner_popup(
    toList([]),
    listPrepend(
      $sc.change_popup_title(toList([]), toList([$el.text("Select one owner")])),
      $list.map(
        users,
        (user) => {
          let name = user.name;
          let picture = user.picture;
          let initials = user.initials;
          return $sc.change_popup_owner_select(
            toList([
              $e.on_click(
                new $msg.UserToggledAssignUserPopupInProposal(
                  user.id,
                  proposal_id,
                ),
              ),
            ]),
            toList([
              $l.row(
                toList([$l.gap(8), $l.align("center")]),
                toList([]),
                toList([
                  $pp.from_user(picture, initials, new $pp.Medium()),
                  $el.text(name),
                ]),
              ),
            ]),
          );
        },
      ),
    ),
  );
}

function change_owner_button(state, proposal_id, users) {
  return $common.change_button(
    toList([$events.return$(new $msg.UserToggledChangeOwnerPopupInProposal())]),
    toList([
      $sc.change_icon(false, $icons.user()),
      $h.text("Change owner"),
      $sc.change_icon(
        !state.proposals.change_owner_popup_opened,
        $icons.arrow_dropdown(),
      ),
      (() => {
        let $ = state.proposals.change_owner_popup_opened;
        if ($) {
          return change_owner_popup(users, proposal_id);
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function status_label(label, effect, content) {
  return $label.label(
    toList([label, $label.on_click(effect), $label.content(content)]),
  );
}

function change_status_button(state, proposal_id) {
  return $common.change_button(
    toList([$events.return$(new $msg.UserToggledChangeStatusPopupInProposal())]),
    toList([
      $sc.change_icon(false, $icons.checkmark()),
      $h.text("Change status"),
      $sc.change_icon(
        !state.proposals.change_status_popup_opened,
        $icons.arrow_dropdown(),
      ),
      (() => {
        let $ = state.proposals.change_status_popup_opened;
        if ($) {
          return $sc.change_status_popup(
            toList([]),
            toList([
              status_label(
                $label.success(),
                new $msg.UserAssignedStatusInProposal(true, proposal_id),
                "Validated",
              ),
              status_label(
                $label.current(),
                new $msg.UserAssignedStatusInProposal(false, proposal_id),
                "In review",
              ),
            ]),
          );
        } else {
          return $el.none();
        }
      })(),
    ]),
  );
}

function questions_by_sheet(computed) {
  let _pipe = $list.group(
    computed.displayed_questions,
    (q) => { return q[1].sheet; },
  );
  return $dict.map_values(_pipe, (_, value) => { return $list.reverse(value); });
}

function find_active_sheet(props, by_sheet) {
  let _block;
  let $ = props.proposal.metadata;
  if ($ instanceof $proposal.Portal) {
    _block = new Ok(new None());
  } else if ($ instanceof $proposal.Document) {
    _block = new Ok(new None());
  } else if ($ instanceof $proposal.Questionnaire) {
    let worksheets = $.worksheets;
    _block = $list.find_map(
      worksheets,
      (worksheet) => {
        let _block$1;
        let _pipe = $dict.get(by_sheet, new Some(worksheet.name));
        let _pipe$1 = $result.unwrap(_pipe, toList([]));
        _block$1 = $list.is_empty(_pipe$1);
        let is_empty = _block$1;
        return $bool.guard(
          is_empty,
          new Error(""),
          () => { return new Ok(new Some(worksheet.name)); },
        );
      },
    );
  } else {
    _block = new Ok(new None());
  }
  let first_non_empty_sheet = _block;
  let $1 = props.proposal.metadata;
  if ($1 instanceof $proposal.Portal) {
    return new None();
  } else if ($1 instanceof $proposal.Document) {
    return new None();
  } else if ($1 instanceof $proposal.Questionnaire) {
    let sheets = $1.sheets;
    let _pipe = $list.find(
      sheets,
      (s) => { return isEqual(new Some(s), props.sheet); },
    );
    let _pipe$1 = $result.map(
      _pipe,
      (var0) => { return new $option.Some(var0); },
    );
    let _pipe$2 = $result.try_recover(
      _pipe$1,
      (_) => { return first_non_empty_sheet; },
    );
    let _pipe$3 = $option.from_result(_pipe$2);
    return $option.flatten(_pipe$3);
  } else {
    return new None();
  }
}

function proposal_menu(model, props, questions) {
  let state = $bright.state(model);
  let computed = $bright.computed(model);
  let proposal_id = props.proposal.id;
  let _block;
  let _pipe = state.organization.users;
  _block = $list.filter(
    _pipe,
    (u) => {
      let _pipe$1 = $project.all_collaborators(props.project);
      return $list.contains(_pipe$1, u.id);
    },
  );
  let users = _block;
  let user = $state.current_user(state);
  let size = $dict.size(state.proposals.selected_questions);
  let hidden = size === 0;
  let by_sheet = questions_by_sheet(computed);
  let active_sheet = find_active_sheet(props, by_sheet);
  let _block$1;
  if (questions instanceof $Empty) {
    _block$1 = false;
  } else if (user instanceof Some) {
    let questions$1 = questions;
    let user$1 = user[0];
    _block$1 = $bool.negate(
      $list.any(
        questions$1,
        (_use0) => {
          let question = _use0[1];
          let selected = $dict.get(
            state.proposals.selected_questions,
            question.id,
          );
          let selected$1 = $result.unwrap(selected, false);
          return ($user.is_admin(user$1) || (isEqual(
            question.owner,
            new Some(user$1.id)
          ))) && !selected$1;
        },
      ),
    );
  } else {
    _block$1 = false;
  }
  let all_selected = _block$1;
  let select_all_questions = $e.on_click(
    new $msg.UserClickedGlobalProposalCheckbox(
      all_selected,
      $computed.filtered_questions_in_page(
        state,
        computed,
        props.page,
        active_sheet,
      ),
    ),
  );
  return $sc.menu_wrapper(
    hidden,
    toList([]),
    toList([
      $sc.menu(
        toList([]),
        toList([
          $l.row(
            toList([$l.gap(16), $l.align("center")]),
            toList([]),
            toList([
              $common.select_all(all_selected, size, select_all_questions),
              $sc.vertical_seperation_bar(toList([]), toList([])),
              change_owner_button(state, proposal_id, users),
              change_status_button(state, proposal_id),
              $s.trash_icon_button(
                toList([$e.on_click(new $msg.UserClosedProposalMenuBar())]),
                toList([$common.selection_bar_icon($icons.cross())]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}

export function view(model, props) {
  let computed = $bright.computed(model);
  let by_sheet = questions_by_sheet(computed);
  let active_sheet = find_active_sheet(props, by_sheet);
  let questions = select_paginated_questions(
    model,
    props,
    by_sheet,
    active_sheet,
  );
  return $s.questionnaire_wrapper(
    toList([]),
    toList([
      $projects_common.header(model, props.project, props.proposal, true),
      mode_bar(model, props),
      blocks_actions(model, props),
      (() => {
        if (questions instanceof Ok) {
          let questions$1 = questions[0];
          return questions_list(model, props, questions$1, active_sheet);
        } else {
          return $l.column(
            toList([$l.flex("1")]),
            toList([]),
            toList([
              $states.no_questions_placeholder(),
              questions_spreadsheet_sheets(props, active_sheet),
            ]),
          );
        }
      })(),
      (() => {
        let _pipe = proposal_menu(
          model,
          props,
          $result.unwrap(questions, toList([])),
        );
        return $element.map(
          _pipe,
          (var0) => { return new $msg.Proposal(var0); },
        );
      })(),
    ]),
  );
}
